export type MuzeInteractionBrush = {
  brush: MuzeInteractionTarget;
};

export type MuzeInteractionInverseSelect = {
  'inverse-select': MuzeInteractionTarget;
};

export type MuzeInteractionHighlight = {
  highlight: MuzeInteractionTarget | MuzeInteractionSideEffect;
};

export type MuzeInteractionFilter = {
  filter: MuzeInteractionSideEffect;
};

export type MuzeInteractionTarget = {
  target: {
    layer: MuzeInteractionHighlight | MuzeInteractionFilter;
  };
};

export type MuzeInteractionSideEffect = {
  sideEffects: MuzePlotHighlighter | MuzeCrossLineEffect | MuzeFilterEffect;
};

export type MuzePlotHighlighter = {
  'plot-highlighter': {
    rules: [MuzeInteractionRule];
  };
};

export type MuzeCrossLineEffect = {
  crossline: {
    enabled: boolean;
  };
};

export type MuzeFilterEffect = {
  filter: {
    lockDomain?: boolean;
  };
  'facet-axis-highlighter'?: {
    enabled: boolean;
  };
};

export type MuzeInteractionRule = {
  target: 'entrySet' | 'exitSet';
  className?: string;
  style?: any;
};

export function makeFilterDomainSideEffect(): MuzeFilterEffect {
  return {
    filter: {
      lockDomain: true,
    },
    'facet-axis-highlighter': {
      enabled: true,
    },
  };
}

export function makeClassInteractionRule(target: 'entrySet' | 'exitSet', className: string) {
  return {
    target: target,
    className: className,
  };
}

export function makePlotHighlighter(rules: [MuzeInteractionRule]) {
  return {
    'plot-highlighter': {
      rules: rules,
    },
  };
}

export function makeInteractionSideEffect(effect: MuzePlotHighlighter | MuzeCrossLineEffect | MuzeFilterEffect) {
  return {
    sideEffects: effect,
  };
}

export function makeInteractionHighlight(target: MuzeInteractionTarget | MuzeInteractionSideEffect) {
  return {
    highlight: target,
  };
}

export function makeInteractionFilter(sideEffects: MuzeInteractionSideEffect) {
  return {
    filter: {
      ...sideEffects,
    },
  };
}

export function makeInteractionTarget(layer: MuzeInteractionHighlight | MuzeInteractionFilter) {
  return {
    target: {
      layer: layer,
    },
  };
}
